module.exports = __webpack_public_path__ + "r-v3/img/hand_blue.e64e605d.svg";